import config from 'config'

import lang from '@/lang'

import TodoStatusEnum from '@/enums/TodoStatus.enum'
import TodoTypesEnum from '@/enums/todo-types.enum'
import moment from 'moment'

const urls = {
  single: 'todo',
  multiple: 'todos',
}

const resourceUrl = `${config.resourceHost}todo`

/**
 * Opens the create drawer straight from a link: `/todos?create=true`.
 *
 * The list already opens it from a route param when a customer is bound to the
 * new todo (`/todos/new/customer/:id`); this is the same idea without a customer,
 * and it keeps the deep link shareable and reload-safe, unlike router state.
 */
export const CREATE_TODO_PARAM = 'create'

export const FilterDue = 'due'
export const FilterOverdue = 'overdue'
export const FilterOwn = 'own'
export const FilterOpen = 'open'
export const FilterDone = 'done'
export const FilterApproved = 'approved'
export const FilterNoted = 'noted'
export const FilterDeclined = 'declined'
export const FilterSigned = 'signed'
export const FilterUnseen = 'unseen'

export default {
  resourceUrl,
  todoListSetting: `${config.resourceHost}setting/userlist/todo`,
  getNewTodo: `${resourceUrl}/new`,
  preview: `${resourceUrl}/preview`,
  uploadUrl: `${resourceUrl}Documents/upload`,

  clientUrl: urls,

  routes: {
    details: `/${urls.single}/`,
    list: `${config.resourceHost}${urls.multiple}`,
  },
  getFilterItems: () => {
    return [
      {
        name: 'all',
        title: lang.label.allCapital,
        quickFilter: {
          status: {
            type: 'set',
            values: [],
          },
        },
      },
      {
        name: FilterOwn,
        title: lang.todo.filter.own,
        quickFilter: {
          // The server resolves this to the authenticated user — it never trusts a
          // value from the request body for who "responsible" means.
          responsibleId: {
            type: 'currentUserResponsible',
          },
        },
      },
      {
        name: FilterOpen,
        title: lang.todo.filter.open,
        quickFilter: {
          status: {
            type: 'set',
            values: [TodoStatusEnum.OPEN],
          },
        },
      },
      {
        // from is today or older and to date is today or in the future
        name: FilterDue,
        title: lang.todo.filter.due,
        quickFilter: {
          status: {
            type: 'set',
            values: [TodoStatusEnum.OPEN],
          },
          dueFromDate: {
            filterType: 'datetime',
            type: 'lessThanOrEqual',
            dateFrom: moment().endOf('day').toISOString(),
          },
          dueToDate: {
            filterType: 'datetime',
            type: 'greaterThanOrEqual',
            dateFrom: moment().startOf('day').toISOString(),
          },
        },
      },
      {
        // to date is in the past
        name: FilterOverdue,
        title: lang.todo.filter.overdue,
        quickFilter: {
          status: {
            type: 'set',
            values: [TodoStatusEnum.OPEN],
          },
          dueFromDate: {
            filterType: 'datetime',
            type: 'lessThanOrEqual',
            dateFrom: moment().endOf('day').toISOString(),
          },
          dueToDate: {
            filterType: 'datetime',
            type: 'lessThan',
            dateFrom: moment().startOf('day').toISOString(),
          },
        },
      },
      {
        name: FilterDone,
        title: lang.todo.filter.done,
        quickFilter: {
          status: {
            type: 'set',
            values: [TodoStatusEnum.DONE],
          },
          type: {
            type: 'set',
            values: [TodoTypesEnum.PROCESS],
          },
        },
      },
      {
        name: FilterSigned,
        title: lang.todo.filter.signed,
        quickFilter: {
          status: {
            type: 'set',
            values: [TodoStatusEnum.DONE],
          },
          type: {
            type: 'set',
            values: [TodoTypesEnum.SIGNATURE],
          },
        },
      },
      {
        name: FilterApproved,
        title: lang.todo.filter.approved,
        quickFilter: {
          status: {
            type: 'set',
            values: [TodoStatusEnum.DONE],
          },
          type: {
            type: 'set',
            values: [TodoTypesEnum.RELEASE],
          },
        },
      },
      {
        name: FilterNoted,
        title: lang.todo.filter.noted,
        quickFilter: {
          status: {
            type: 'set',
            values: [TodoStatusEnum.DONE],
          },
          type: {
            type: 'set',
            values: [TodoTypesEnum.ATTENTION],
          },
        },
      },
      {
        name: FilterDeclined,
        title: lang.todo.filter.declined,
        quickFilter: {
          status: {
            type: 'set',
            values: [TodoStatusEnum.DECLINED],
          },
        },
      },
      {
        name: FilterUnseen,
        title: lang.todo.filter.unseen,
        quickFilter: {
          responsibleId: {
            type: 'currentUserResponsible',
          },
          isSeen: {
            type: 'unseen',
          },
        },
      },

    ]
  },
}
